// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Footer-module__footer-idwjI {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.nightbot-Footer-module__footerContainer-Xetgu,
.nightbot-Footer-module__socialFooterContainer-qnrMD {
  width: 100%;
  background-color: var(--mantine-color-gray-10);
}

.nightbot-Footer-module__socialFooterContainer-qnrMD {
  padding: 16px 0px;
}

.nightbot-Footer-module__socialFooterContainer-qnrMD .nightbot-Footer-module__footer-idwjI {
    align-items: center;
  }

.nightbot-Footer-module__footerContainer-Xetgu {
  padding: 64px 0px;
}

.nightbot-Footer-module__footerLinks-sXGyY {
  display: flex;
  gap: 8px;
}

.nightbot-Footer-module__footerLinkStack-Xptyr {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: flex-start;
}

@media (max-width: 768px) {
  .nightbot-Footer-module__footerContainer-Xetgu > .nightbot-Footer-module__footer-idwjI {
    flex-direction: column;
    gap: 32px;
  }

  .nightbot-Footer-module__socialFooterContainer-qnrMD > .nightbot-Footer-module__footer-idwjI {
    flex-direction: column-reverse;
    gap: 8px;
  }
}

.nightbot-Footer-module__divider-wPTiJ {
  width: 100%;
  border-color: var(--mantine-color-gray-9);
}

.nightbot-Footer-module__landingFooter-EmT4a {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AAKnB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;AACF;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb","sourcesContent":[".footer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.footerContainer,\n.socialFooterContainer {\n  width: 100%;\n  background-color: var(--mantine-color-gray-10);\n}\n\n.socialFooterContainer {\n  padding: 16px 0px;\n\n  .footer {\n    align-items: center;\n  }\n}\n\n.footerContainer {\n  padding: 64px 0px;\n}\n\n.footerLinks {\n  display: flex;\n  gap: 8px;\n}\n\n.footerLinkStack {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-self: flex-start;\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n  .footerContainer > .footer {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .socialFooterContainer > .footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n}\n\n.divider {\n  width: 100%;\n  border-color: var(--mantine-color-gray-9);\n}\n\n.landingFooter {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `nightbot-Footer-module__footer-idwjI`,
	"footerContainer": `nightbot-Footer-module__footerContainer-Xetgu`,
	"socialFooterContainer": `nightbot-Footer-module__socialFooterContainer-qnrMD`,
	"footerLinks": `nightbot-Footer-module__footerLinks-sXGyY`,
	"footerLinkStack": `nightbot-Footer-module__footerLinkStack-Xptyr`,
	"divider": `nightbot-Footer-module__divider-wPTiJ`,
	"landingFooter": `nightbot-Footer-module__landingFooter-EmT4a`
};
export default ___CSS_LOADER_EXPORT___;
